export class UploadTask {
     
    private id: string; 
    private siteId: string; 
    private month: number; 
    private year: number; 
    private tmpFolder: string; 
    private imageOrder: string[]; 
    private uploadStatus: string; 
    private createdAt: Date; 
    private modifiedAt: Date;

    constructor( id: string, siteId: string, month: number, year: number, tmpFolder: string, imageOrder: string[], uploadStatus: string, createdAt: Date, modifiedAt: Date,) {
        this.id = id;
        this.siteId = siteId;
        this.month = month;
        this.year = year;
        this.tmpFolder = tmpFolder;
        this.imageOrder = imageOrder;
        this.uploadStatus = uploadStatus;
        this.createdAt = createdAt;
        this.modifiedAt = modifiedAt;
        
    }

    
    public Id = (): string => {
        return this.id
    }
    public SiteId = (): string => {
        return this.siteId
    }
    public Month = (): number => {
        return this.month
    }
    public Year = (): number => {
        return this.year
    }
    public TmpFolder = (): string => {
        return this.tmpFolder
    }
    public ImageOrder = (): string[] => {
        return this.imageOrder
    }
    public UploadStatus = (): string => {
        return this.uploadStatus
    }
    public CreatedAt = (): Date => {
        return this.createdAt
    }
    public ModifiedAt = (): Date => {
        return this.modifiedAt
    }
}